
import * as statusApi from '../api/status'
import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'
import { capitalizeFirstLetter } from '../../misc/utils'

export const UPDATE_IDEA_STATUS = "UPDATE_IDEA_STATUS"

function formatStatusMessage(statusType, status) {
    var sType = capitalizeFirstLetter(statusType).replace("_", " ")

    return `Changed ${sType} to ${capitalizeFirstLetter(status)}`
}

export const updateIdeaStatus = (statusType, idea_id, status) => (dispatch) => {
    statusApi.patchObj(statusType, idea_id, status).then(data => {
        dispatch({
            type: UPDATE_IDEA_STATUS,
            payload: data
        })
        dispatch(showSuccess(formatStatusMessage(statusType, status)))
    }).catch(err => dispatch(handleApiError(err)))
}
